// extracted by mini-css-extract-plugin
export default {"logo":"logo___zNyf","betaLogo":"betaLogo__YaMGQ","bigbeatLogo":"bigbeatLogo__CadQe","cropSafeLogo":"cropSafeLogo__xxWF9","odysseus-prelander":"odysseus-prelander__sScSj","herocity":"herocity__Zb1to"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"logo\":\"logo___zNyf\",\"betaLogo\":\"betaLogo__YaMGQ\",\"bigbeatLogo\":\"bigbeatLogo__CadQe\",\"cropSafeLogo\":\"cropSafeLogo__xxWF9\",\"odysseus-prelander\":\"odysseus-prelander__sScSj\",\"herocity\":\"herocity__Zb1to\"}";
        // 1787130556861
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  